// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2EaL-","log":"ModalInventoryLogs_log__3RT-f","date":"ModalInventoryLogs_date___FAJ8","userName":"ModalInventoryLogs_userName__1fQJb"};